/*
prefix // prefix is sorted in order of legnth
ext
  trie -> ~/i18n/rust/verfs/src/lib.rs
    
*/

export default (path, pet) => {}
